module.exports = __webpack_public_path__ + "media/wenquan.2b010ed1.mp3";